import { Constants } from '@shared/utils/constants';
import { copyState, initialCloudsIndustryDataState } from './../../State';
import { commonEntityDataReducer } from './commonEntityDataReducer';
export default function cloudsIndustryDataReducer(state = initialCloudsIndustryDataState, action) {
    const newState = copyState(state);
    return commonEntityDataReducer(Constants.EntityType.CloudsIndustry, state, action);
}
